
export default props=>(<div className="">
    <style jsx>{`

.label-container{
    position: absolute;
    left: ${props.x}%;
    top: ${props.y}%;



    height: 30px;
    line-height: 30px;
}

.f1{
    width: 0;
    height:0;
    border-top:solid 15px transparent;
    border-right:solid 15px #55d5ce;;
    border-bottom:solid 15px transparent;
    border-left:solid 15px transparent;
}

.f2{
    margin: 0;
    border: 0;
    padding: 0 15px;

    background-color: #55d5ce;
    color: white;

    height: 30px;
    line-height: 30px;
    vertical-align: top;

    font-size: 12px;
}

.f3{
    background-color: #55d5ce;;
    vertical-align: top;
    margin: 0;
    border: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
}

.f3 img{
    padding: 3px;
}


`}</style>

    <div className="label-container" style={{ display: props.d}}>
        <div className="dib f1" />
        <div className="dib f2">
            {(props.url?
                <a href={props.url} target="_blank">{props.trademark}</a>:
                props.trademark
            )}
            
        </div>
        <div className="dib f3">
            <img src="/assets/images/x_white.svg" />
            <img src="/assets/images/next.svg" />
        </div>
    </div>


</div>);

